export default __webpack_public_path__ + "static/media/atras-icon.a98fc1f3.svg";